export default __webpack_public_path__ + "static/media/sip1.cb20bd57.jpg";